<template>
  <div>
    <div class="home">
      <div class="home-a">
        <div class="block">
          <div class="block-top">
            <div class="top-header">
              一一 湖南莘宇聚鑫信息科技有限公司快捷支付平台 一一
            </div>

            <div class="top-title">联创运管 2025</div>
            <div class="top-text">扬帆 · 起航</div>
          </div>

          <div class="block-input">
            <el-input
              v-model="phone"
              placeholder="请输入手机号或会员id"
              clearable
              oninput="value=value.replace(/[^0-9.]/g,'')"
              type="Num"
            >
              <template slot="prepend">
                <div class="input-title">当前ID/手机号：</div>
              </template>
            </el-input>
          </div>

          <div class="a" @click="priceStop">
            点此处立即使用支付宝进行订单的结算或充值
          </div>
          <img src="../assets/bottom.jpg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginAffirm, getsettingrechargePay } from "../api/index";

export default {
  data() {
    return {
      phone: "",
    };
  },
  created() {
    if (this.$route.query.phone) {
      this.phone = this.$route.query.phone;
    }
  },
  methods: {
    appletMet() {
      let params = {
        number: this.phone,
      };

      loginAffirm(params).then((res) => {
        if (res.errorCode == null) {
          this.userObj = res.resultData;

          this.$router.push({
            path: "/about",
            query: {
              phone: this.phone,
              price: this.$route.query.price,
            },
          });
        } else {
          this.$message.error(res.errorMessage);
        }
      });
    },
    priceStop() {
      this.appletMet();
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  .home-a {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .block {
      img {
        width: 100%;
        height: 100%;
      }

      .block-top {
        .top-header {
          display: flex;
          align-items: center;
          justify-content: space-around;

          font-size: 13px;
          font-weight: bold;
          color: #332c98;
        }

        .top-title {
          margin: 20px 0;
          font-size: 30px;
          font-weight: 500;
          color: #342c99;
        }

        .top-text {
          font-size: 30px;
          font-weight: 500;
          color: #342c99;
          margin-bottom: 30px;
        }
      }

      .block-input {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        margin-bottom: 20px;
        display: flex;
        align-items: center;

        .input-title {
          font-size: 14px;
          font-weight: bold;
        }

        /deep/ .el-input {
          width: 100%;
        }

        /deep/ .el-input-group__prepend {
          color: unset;
          background-color: unset;
          border-right: 0;
          padding: 0 0 0 10px ;
        }

        /deep/ .el-input__inner {
          border: 1px solid #DCDFE6;
          border-left: 0;
          padding-left: 0;
        }

        /deep/ .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .a {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        border-radius: 5px;
        font-weight: bold;
        background: #2a82e2;
        color: #fff;
        margin: 0 10px;
      }
    }
  }
}
</style>
